export enum PageMode {
  "Desktop",
  "Tablet",
  "Mobile"
}
